import AddressTab from './AddressTab.vue';

const { __ } = wp.i18n;

const title = __( 'Address Autocomplete API', 'jet-form-builder' );
const component = AddressTab;

export {
	title,
	component
}